import t from "react";
import { c as s, t as i } from "./app-a75c1d35.mjs";
import { B as c } from "./Block-9b78bd10.mjs";
const l = "section", _ = "section__content", C = "block__content", b = "mobile", u = "desktop", g = "section__content__component", x = "section__content__component__title", T = "section__content__description", D = "section__content__description__footer", E = "section__content__description__body-text", y = "section__content__description__sub-heading", e = {
  section: l,
  sectionContent: _,
  blockContent: C,
  mobile: b,
  desktop: u,
  sectionContentComponent: g,
  sectionContentComponentTitle: x,
  sectionContentDescription: T,
  sectionContentDescriptionFooter: D,
  sectionContentDescriptionBodyText: E,
  sectionContentDescriptionSubHeading: y
};
function h({ content: n }) {
  return /* @__PURE__ */ t.createElement(
    "h2",
    {
      className: s(
        i.textsComponentTitleBold,
        e.sectionContentComponentTitle
      ),
      itemProp: "name"
    },
    n
  );
}
function N({ content: n }) {
  return /* @__PURE__ */ t.createElement(
    "h3",
    {
      className: s(
        i.textsParagraphSubtitleBold,
        e.sectionContentDescriptionSubHeading
      ),
      itemProp: "name"
    },
    n
  );
}
function S(n) {
  const { content: r, isFooterSection: o } = n;
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: s(e.sectionContentDescriptionBodyText, {
        [i.textsLeadText]: o,
        [i.richText]: o,
        [i.textsBodyText]: !o
      }),
      itemProp: "description"
    },
    r
  );
}
function P(n) {
  const { id: r, heading: o, subHeading: a, bodyText: m, isFooterSection: d } = n, p = s(
    e.sectionContentDescription,
    d ? e.sectionContentDescriptionFooter : ""
  );
  return /* @__PURE__ */ t.createElement(
    c,
    {
      as: "section",
      id: r,
      topPadding: o ? c.Padding.SMALL : c.Padding.NONE,
      bottomPadding: c.Padding.LARGE,
      className: e.section,
      "data-testid": "article-section-block"
    },
    /* @__PURE__ */ t.createElement(
      c.Content,
      {
        className: e.sectionContent,
        "data-testid": "article-section-block-content",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      o && /* @__PURE__ */ t.createElement("article", { className: e.sectionContentComponent }, /* @__PURE__ */ t.createElement(h, { content: o })),
      /* @__PURE__ */ t.createElement(
        "article",
        {
          className: p,
          "data-testid": "article-section-content-description"
        },
        a && /* @__PURE__ */ t.createElement(N, { content: a }),
        /* @__PURE__ */ t.createElement(S, { isFooterSection: d, content: m })
      )
    )
  );
}
export {
  P as ArticleSection
};
//# sourceMappingURL=ArticleSection.js.map
